import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { SafeConversion } from '../../types/safes.types';
import { useAppQuery } from '../use-app-query.hook';

export const useSafeConversion = ({
  companyId,
  conversionId,
  enabled = true,
}: {
  companyId: string;
  conversionId: string;
  enabled?: boolean;
}) => {
  const queryClient = useQueryClient();

  const { data: safeConversion, isLoading } = useAppQuery<SafeConversion>({
    queryKey: [QueryKey.GET_SAFE_CONVERSION, companyId, conversionId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'safes', 'safe-conversion', conversionId],
      }),
    enabled: !!companyId && !!conversionId && enabled,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SAFE_CONVERSION] });
  }, [queryClient]);

  return {
    invalidateQuery,
    safeConversion,
    isLoading,
  };
};
